import { Form, Input, Select } from "antd";
import { IClient } from "@/modules/client/clients.interface";
import { LandingPageFields } from "./LandingPageFields";
import { ALL_CLIENTS } from "./types";
import style from "./style.module.css";

interface NewTemplateMetadataSectionProps {
  clients: IClient[];
  isLoadingClients: boolean;
  hasClientsError: boolean;
}

export function NewTemplateMetadataSection({
  clients,
  isLoadingClients,
  hasClientsError,
}: NewTemplateMetadataSectionProps) {
  return (
    <>
      <Form.Item label="Assessment Template Name" htmlFor="templateName">
        <p className={style.fieldDescription} id="templateName-desc">
          Internal display name for the template
        </p>
        <Form.Item
          name="templateName"
          rules={[{ required: true, whitespace: true, message: "Please enter a template name." }]}
          noStyle={true}
        >
          <Input id="templateName" aria-describedby="templateName-desc" />
        </Form.Item>
      </Form.Item>

      <Form.Item label="Client" htmlFor="clientId">
        <p className={style.fieldDescription} id="clientId-desc">
          If this is a client-specific template, please select the client. Otherwise, select "All Clients"
        </p>
        <Form.Item name="clientId" rules={[{ required: true, message: "Please select a client." }]} noStyle={true}>
          {hasClientsError ? (
            <div className={style.fieldError}>
              There was an issue loading clients. Please reload the page to try again.
            </div>
          ) : (
            <Select
              id="clientId"
              placeholder="Select a client"
              options={[
                { value: ALL_CLIENTS, label: "All Clients" },
                ...clients.map((client) => ({ value: client.clientId, label: client.name })),
              ]}
              loading={isLoadingClients}
              showSearch={true}
              optionFilterProp="label"
              aria-describedby="clientId-desc"
            />
          )}
        </Form.Item>
      </Form.Item>

      <LandingPageFields />
    </>
  );
}
